import { createActions } from 'utils/actions';

/**
 * Redux actions for send email.
 *
 * @type {Object}
 */
export const sendEmail = createActions('inProductMarketing', 'SEND_EMAIL', {
    asPromise: true,
});

/**
 * Redux actions for fetching upsell ads
 *
 * @type {Object}
 */
export const fetchUpsellAds = createActions('inProductMarketing', 'FETCH_UPSELL_ADS', {
    asPromise: true,
});
